import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';

import ReactToPrint from "react-to-print";

import moment from 'moment';

//views
import SchedulerWeekView from '../scheduler/SchedulerWeekView';
import SchedulerMonthView from '../scheduler/SchedulerMonthView';
import SchedulerDailyView from '../scheduler/SchedulerDailyView';
import AddCategoryModal from '../scheduler/AddCategoryModal';
import ActivityDetailsModal from '../scheduler/ActivityDetailsModal';
import ActivityFiltersDrawer from '../scheduler/ActivityFiltersDrawer';


//material components
import AppBar from "@material-ui/core/AppBar";
import { Button, TextField } from '@material-ui/core'
import { Grid } from '@material-ui/core'
import IconButton from '@material-ui/core/IconButton';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from "@material-ui/core/Typography";
import { Autocomplete } from '@material-ui/lab';

//engage Components
import { RenderSelectCustom } from '../../utils/engageComponents'

//Icons
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import PrintIcon from '@material-ui/icons/Print';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';

//fontAwesome
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faCheck,
    faFilter
} from "@fortawesome/free-solid-svg-icons";


//Actions
import { GetCategoriesByCommunityId, GetCategoryIcons, DeleteCategory } from '../../actions/categoryActions'
import { SetHeaderButtons } from '../../actions/headerButtonsActions';
import { GetCalendarActivities } from '../../actions/activityAction';
import { getAllCommunities } from '../../actions/communityActions';
import { SuperUserDropDown } from '../../components/SuperUserDropDown/SuperUserDropDown';

import { SweetConfirmationAlert } from '../../components/Alert/sweetAlert';
import Alert from 'react-s-alert';
import { UpdateCurrentLocation } from '../../actions/currentUrlActions';
import FarCalendarAlt from '../../assets/svgs/regular/calendar-alt';

import html2canvas from 'html2canvas';
import SchedulerImagePreview from '../scheduler/SchedulerImagePreview';
import WeeklySelectionTool from '../../utils/WeeklySelectionTool';
import DaySelectionTool from '../../utils/DaySelectionTool';
import isValid from "date-fns/isValid";

const validate = (values) => {
};


export class Scheduler extends Component {
    constructor(props) {
        super()

        this.state = {
            openWeekView: false,
            //stepCount
            stepCount: 0,
            //community 
            CommunitySelected: undefined,
            //Add category
            openAddCategoryModal: false,
            //ActivityDetails
            openActivityDetails: false,
            activityDetailsIdAnchorEl: undefined,
            activityDetailsActivityObject: undefined,
            //Activity Filters
            activityFiltersAnchorElId: undefined,
            filterObj: undefined,
            //ActivitySearch
            searchInput: undefined,
            openSearchComponent: false,
            //AddEventModal
            openAddEventModal: false,
            //Current month
            currentDate: new Date(),
            //selectedMonth
            selectedDate: undefined,
            //DisabledIcon
            disabledBackIcon: true,
            //rootFontSize
            rootFontSize: {
                name: 'xs',
                fontSize: '58%',
                maxWidht: 600,
            },
            openCommunityCombo: false,
            categorySelected: undefined,
            //UpdateIsNedeed
            updateIsNeeded: null,
            schedulerOptions: [{ name: 'Monthly' }, { name: 'Weekly' }, { name: 'Daily' }],
            schedulerOptionSelected: { name: 'Monthly' },
            openSchedulerCompo: false,
            //pdfRef
            pdfRef: React.createRef(),

            months: [moment(new Date()).format('MMM YYYY')],
            currentMonth: moment(new Date()).format('MMM YYYY'),
            startSelectedWeek: new Date(moment(new Date()).startOf('week')),
            daySelected: new Date(moment(new Date()).startOf('day'))
        }
    };

    Styles = {
        titleEngage: {
            color: '#F0EFEF',
            fontSize: '20px',
            // fontWeight: 'bold',
            textAlign: 'left',
            marginBottom: '10px'
        },
        title: {
            flexGrow: 1
        },
        globalActions: {
            marginLeft: 'auto',
            marginRight: '0px'
        },
    };

    componentDidMount() {
        document.title='Schedule'

        //fill the months array
        const months = this.state.months

        for (let i = 1; i < 12; i++) {
            const now = new Date();

            const nextMonth = moment(now).add(i, 'months').format('MMM YYYY');
            months.push(nextMonth)

        }

        this.setState({ months: [...months] })

        if (!this.props.communityData || (this.props.communityData && this.props.communityData.length === 0))
            this.props.getAllCommunities();

        const communityId = (localStorage.getItem('communityId') && localStorage.getItem('communityId').length > 0) ? localStorage.getItem('communityId') : undefined;

        if (communityId) {
            this.props.GetCategoriesByCommunityId(communityId);
        }

        this.GetCategories();

        window.addEventListener("resize", this.resize.bind(this));
        this.resize();

        setTimeout(() => {
            this.SetHeaderButtons();
        }, 200);
    };

    componentWillUnmount() {

        this.props.SetHeaderButtons(undefined);
    };

    SetHeaderButtons = () => {
        const headerButtons = this.getHeaderButtons();
        this.props.SetHeaderButtons(headerButtons)
    };

    getHeaderButtons = () => {

        return (
            <Grid item xs={6} sm={5} md={3} lg={3}
                id='AddEventButton'
                style={{ width: '168px' }}
                className={(localStorage.getItem('communityId') && localStorage.getItem('communityId').length > 0) ? "blueBottomButon appbtnBarButton" : "disableBottomButon appbtnBarButton"}
                disabled={!(localStorage.getItem('communityId') && localStorage.getItem('communityId').length > 0)}
                onClick={this.handleAddActivity}
            >
                Add Activity

            </Grid>
        )
    };

    handleAddActivity = () => {
        this.props.history.push({ pathname: '/activities', state: { activityObject: {} } })
    }

    GetCategories = () => {
        const communityId = (localStorage.getItem('communityId') && localStorage.getItem('communityId').length > 0) ? localStorage.getItem('communityId') : undefined;

        if (communityId && communityId.length > 0) {
            this.props.GetCategoriesByCommunityId(communityId)
            this.props.GetCategoryIcons();
        } else {
            this.props.GetCategoriesByCommunityId('')
            this.props.GetCategoryIcons();
        }
    };

    resize() {
        const sizes = {
            xs: {
                name: 'xs',
                fontSize: '58%',
                maxWidht: 600,
            },
            sm: {
                name: 'sm',
                fontSize: '60%',
                maxWidht: 960,
            },
            md: {
                name: 'md',
                fontSize: '80%',
                maxWidht: 1280,
            },
            lg: {
                name: 'lg',
                fontSize: '100%',
                maxWidht: 1920,
            },
        };

        const windowWidth = window.innerWidth;

        let rootFontSize = sizes.xs;

        if (windowWidth > sizes.md.maxWidht) {
            rootFontSize = sizes.lg;
        } else if (windowWidth > sizes.sm.maxWidht) {
            rootFontSize = sizes.md;
        } else if (windowWidth > sizes.xs.maxWidht) {
            rootFontSize = sizes.sm;
        } else {
            rootFontSize = sizes.xs;
        }

        this.setState({ rootFontSize: rootFontSize });
    };


    //AddStep
    AddStep = (step) => {
        let futureStep = this.state.stepCount ? this.state.stepCount : 0;

        if (step === 1) {
            futureStep = futureStep + 1;
        } else {
            futureStep = futureStep - 1;
        }

        this.FilterActivitiesByDate(futureStep, this.state.CommunitySelected)

        if (step === -1) {
            const currentYear = moment(this.state.currentDate).format('YYYY');
            const currentMonth = moment(this.state.currentDate).format('MM');
            const currentWeek = moment(this.state.currentDate).format('WW');
            const currentDay = moment(this.state.currentDate).dayOfYear();


            let selectedYear = moment(this.state.currentDate).add(this.state.stepCount + step, 'months').format('YYYY');
            let selectedMonth = moment(this.state.currentDate);
            let selectedWeek = moment(this.state.currentDate);
            let selectedDay = new moment(this.state.currentDate);

            if (this.state.stepCount > 0) {
                selectedMonth = moment(this.state.currentDate).add(this.state.stepCount + step, 'months')
                selectedWeek = moment(this.state.currentDate).add(this.state.stepCount + step, 'week');
                selectedDay = new moment(this.state.currentDate).add(this.state.stepCount + step, 'days');
            } else if (this.props.stepCount < 0) {
                selectedMonth = moment(this.state.currentDate).subtract(-1 * this.state.stepCount + step, 'months')
                selectedWeek = moment(this.state.currentDate).subtract(this.state.stepCount + step, 'week');
                selectedDay = new moment(this.state.currentDate).subtract(this.state.stepCount + step, 'days');
            }

            const selectedMonthNum = selectedMonth.format('MM');
            const selectedWeekNum = selectedWeek.format('WW');
            const selectedDayNum = selectedDay.dayOfYear();

            if (this.state.schedulerOptionSelected && this.state.schedulerOptionSelected.name && this.state.schedulerOptionSelected.name.toLocaleLowerCase() === 'weekly') {
                const prevWeek = moment(this.state.startSelectedWeek).subtract(1, 'week').format();
                if (selectedMonthNum === currentMonth && currentYear === selectedYear)
                    this.setState(
                        (prevState) => ({ stepCount: prevState.stepCount + step, disabledBackIcon: true, startSelectedWeek: new Date(prevWeek) })
                    )
                else
                    this.setState(
                        (prevState) => ({ stepCount: prevState.stepCount + step, startSelectedWeek: new Date(prevWeek) })
                    );

                this.formatWeekSelectLabel(new Date(prevWeek))

            } else if (this.state.schedulerOptionSelected && this.state.schedulerOptionSelected.name && this.state.schedulerOptionSelected.name.toLocaleLowerCase() === 'monthly') {
                (selectedWeekNum === currentWeek && currentYear === selectedYear) ?
                    this.setState(
                        (prevState) => ({ stepCount: prevState.stepCount + step, disabledBackIcon: true, currentMonth: this.state.months[prevState.stepCount + step] })
                    )
                    :
                    this.setState(
                        (prevState) => ({ stepCount: prevState.stepCount + step, currentMonth: this.state.months[prevState.stepCount + step] })
                    );


            } else if (this.state.schedulerOptionSelected && this.state.schedulerOptionSelected.name && this.state.schedulerOptionSelected.name.toLocaleLowerCase() === 'daily') {
                const prevDay = moment(this.state.daySelected).subtract(1, 'day').format();
                (selectedDayNum === currentDay && currentYear === selectedYear) ?
                    this.setState(
                        (prevState) => ({ stepCount: prevState.stepCount + step, disabledBackIcon: true, daySelected: new Date(prevDay) })
                    )
                    :
                    this.setState(
                        (prevState) => ({ stepCount: prevState.stepCount + step, daySelected: new Date(prevDay) })
                    );
                this.formatSelectedDayLabel(new Date(prevDay))
            }

        } else {
            if (this.state.schedulerOptionSelected.name === 'Monthly') {
                this.setState(
                    (prevState) => ({ stepCount: prevState.stepCount + step, disabledBackIcon: false, currentMonth: this.state.months[prevState.stepCount + step] })
                );
            } else if (this.state.schedulerOptionSelected.name === 'Weekly') {

                const nextWeek = moment(this.state.startSelectedWeek).add(1, 'weeks').format()

                this.setState(
                    (prevState) => ({ stepCount: prevState.stepCount + step, disabledBackIcon: false, startSelectedWeek: new Date(nextWeek) })
                );

                this.formatWeekSelectLabel(new Date(nextWeek))

            } else if (this.state.schedulerOptionSelected.name === 'Daily') {
                const nextDay = moment(this.state.daySelected).add(1, 'day').format()

                this.setState(
                    (prevState) => ({ stepCount: prevState.stepCount + step, disabledBackIcon: false, daySelected: new Date(nextDay) })
                );

                this.formatSelectedDayLabel(new Date(nextDay))
            }

        }
    };


    FilterActivitiesByDate = (futureStep, CommunitySelected) => {
        const isMonthlyView = !this.state.openWeekView;
        const stepsinView = futureStep ? futureStep : this.state.stepCount ? this.state.stepCount : 0;

        const currentDate = moment(new Date());
        let startDate = undefined;
        let endDate = undefined;

        const scale = isMonthlyView ? 'month' : 'week'
        if (isMonthlyView) {
            startDate = currentDate.clone().add(stepsinView, scale + 's').startOf(scale).startOf('week');
            endDate = currentDate.clone().add(stepsinView, scale + 's').endOf(scale).endOf('week');
        } else {
            startDate = currentDate.clone().add(stepsinView, scale + 's').startOf(scale);
            endDate = currentDate.clone().add(stepsinView, scale + 's').endOf(scale);
        }

        if (startDate && endDate && CommunitySelected) {

            this.GetFilteredActivities(startDate, endDate, CommunitySelected);
        }


    }
    //Search communityOption
    SearchCommunityObject = (communityId) => {
        let community = undefined;

        if (
            (communityId && communityId.length > 0) &&
            (this.props.communityData && this.props.communityData.length > 0)
        ) {
            community = this.props.communityData.find(item => item.communityId === communityId)
        }

        this.setState({ CommunitySelected: community }, () => this.FilterActivitiesByDate(0, community));
        //return community;
    };

    GetCategoryBadge(categoryName) {
        let categoryWords = categoryName.split(' ');

        categoryWords = categoryWords.filter(item => item !== '&');

        const CategoryBadge = categoryWords.map(word => word.charAt(0).toUpperCase()).join('').slice(0, 2);

        return CategoryBadge;
    };

    //Handlers
    onFilterChange = (filterObj) => {
        if (filterObj) {
            this.setState({
                filterObj: filterObj
            });
        }
    }

    OnActivityClick = (activityObject, idActivityAnchorEl) => {
        this.setState({
            activityDetailsIdAnchorEl: idActivityAnchorEl,
            activityDetailsActivityObject: activityObject,
            openActivityDetailsModal: true
        })


    };


    OnGoToActivity = (activityObj) => {
        try {
            if (activityObj) {
                this.props.history.push({ pathname: '/activities', state: { activityObject: activityObj } });
            }
        } catch (err) { }

    };

    OnCreateEventClick = (eventType) => {
        switch (eventType) {
            case '1':
                this.props.history.push({ pathname: '/activities', state: { activityObject: {} } })

                break;
            case '2':
                this.props.history.push({ pathname: '/dinings', state: { diningObject: {} } })
                break;
            default:
        }
    }

    onClickFiltersPopOver = () => {
        try {

            this.setState({
                openActivityFiltersPopOver: true,
                activityFiltersAnchorElId: 'filtersButton',
            })

        } catch (err) { }
    };

    //#region  Printing
    printDiv = () => {
        window.frames["print_frame"].document.body.innerHTML = document.getElementById("printableTable").innerHTML;
        window.frames["print_frame"].window.focus();
        window.frames["print_frame"].window.print();
    }

    handleEditCategory = (e, category) => {

        this.setState({ categorySelected: category, openAddCategoryModal: true });
    }

    handleDelete = async (e, category) => {

        const title = 'Are you sure you want to delete the category?';

        const { isConfirmed } = await SweetConfirmationAlert(title, 'alert_DeleteCategory');

        if (isConfirmed) {
            this.deleteCategory({}, category);
        }

    }

    deleteCategory = (event, category, isActive) => {
        if (category._id) {
            this.props.DeleteCategory(category._id);
        }
        Alert.closeAll();
        this.handleClose();
    }


    handleClose = () => {

        this.setState({ openAddCategoryModal: false, categorySelected: undefined });

        if (localStorage.getItem('communityId')) {
            setTimeout(() => { this.GetCategories(); }, 200);
        }
    }
    //#endregion
    handleCommunityCombo = () => {
        this.setState((prevState) => ({ openCommunityCombo: !prevState.openCommunityCombo }));
    }
    handleCommunityOnBlur = () => {
        this.setState({ openCommunityCombo: false })
    }

    onCloseActivityDetails = () => {
        this.setState({
            openActivityDetails: false,
            activityDetailsAnchorEl: undefined,
            activityDetailsActivityObject: undefined,
        });
    };

    GetFilteredActivities = async (startDate, endDate, CommunitySelected) => {
        let activities = await this.props.GetCalendarActivities(CommunitySelected.communityId);

        let activitiesFiltered = [...activities].filter(item => moment(item.date) >= startDate && moment(item.endDate) <= endDate);

        let activitiesNames = [...new Set(activitiesFiltered.map(item => item.title.trim()))]
        activitiesNames = activitiesNames.map((item, index) => ({ id: index, name: item }));

        let newFilteredObject = this.state.filterObj ? { ...this.state.filterObj } : {};
        //newFilteredObject.activitiesData =  activitiesNames;

        this.setState({
            baseActivities: activities,
            activitiesfiltered: activitiesFiltered,
            filterObj: newFilteredObject,
            activitiesNames: activitiesNames,
        })
    }
    ToggleScaleSelected = (optionselected) => {
        this.setState({ openWeekView: (optionselected === 0) ? false : true, stepCount: 0 },
            () => this.FilterActivitiesByDate(this.state.stepCount, this.state.CommunitySelected));
    }


    //#region Handlers
    searchComponentChangeHandler = (input) => {

        const newInput = (input && input.length > 0) ? input : undefined;

        let newFilterObj = this.state.filterObj ? { ...this.state.filterObj } : {};
        newFilterObj.searchInput = newInput

        this.setState({ filterObj: newFilterObj });
    }

    searchClickHandler = (open) => {
        const isOpen = open ? open : false;

        this.setState({ openSearchComponent: isOpen });
    }
    //#endregion


    //#region INNER COMPONENTS

    //#endregion


    setUpdateIsNeeded = (isUpdateNeeded) => {

        this.setState({ updateIsNeeded: isUpdateNeeded });
    }
    localStorageRemoveItem = (key) => {
        try {
            if (key) {
                localStorage.removeItem(key);
            }

        } catch (err) { }
    };

    localStorageSetItem = (key, value) => {
        try {
            if (key && value) {
                this.setState({ stepCount: 0, disabledBackIcon: true })
                localStorage.setItem(key, value);
            }
        } catch (err) { }
    };

    setLocalState = (objectToSet) => {
        try {
            this.setState({
                ...objectToSet, schedulerOptionSelected: { name: 'Monthly' }, currentMonth: this.state.months[0],
                startSelectedWeek: new Date(moment(new Date()).startOf('week')), daySelected: new Date(moment(new Date()).startOf('day'))
            })
        } catch (err) { }
    };

    RenderSchedulerOptionSelect = ({ props }) => {
        return (<Grid item container ></Grid>)
    };

    onChangeSelectHandler = (newItem) => {
        try {
            if (!newItem) return undefined;

            this.setState({
                schedulerOptionSelected: newItem, openSchedulerCompo: false, stepCount: 0, disabledBackIcon: true,
                currentMonth: this.state.months[0], startSelectedWeek: new Date(moment(new Date()).startOf('week')), daySelected: new Date(moment(new Date()).startOf('day'))
            });

        } catch (err) { }
    }
    onBlurRenderSelectCustom = () => {
        this.setState({ openSchedulerCompo: false })
    }

    openHandlerRenderSelectCustom = () => {
        this.setState((prevState) => ({ openSchedulerCompo: !prevState.openSchedulerCompo }));
    }

    GenerateImageFromCalendar = async () => {
        try {

            const element = document.getElementById('canvasContainer');

            if (!element) return undefined;

            html2canvas(element, { logging: false, useCORS: false, allowTaint: true }).then(
                canvas => {

                    this.setState({ imagePreview: canvas });
                }
            );

        } catch (err) { }
    }

    onCloseImagePreviewModal = () => {
        try {
            this.setState({ imagePreview: undefined });
        } catch (err) { }
    }

    handleSelectMonth = (month) => {

        //Get the index of the new selection
        const index = this.state.months.indexOf(month)

        this.FilterActivitiesByDate(index, this.state.CommunitySelected)

        this.setState({
            currentMonth: month,
            stepCount: index,
            disabledBackIcon: month !== moment(new Date()).format('MMM YYYY') ? false : true
        })


    }

    handleSelectWeek = (week) => {
        //Take the week and get the start of the month
        const msInWeek = 1000 * 60 * 60 * 24 * 7;

        const weekInCourse = moment(new Date()).startOf('week').format()

        const diff = Math.round(Math.abs(new Date(weekInCourse) - new Date(week)) / msInWeek)

        this.formatWeekSelectLabel(week)

        this.setState({
            startSelectedWeek: new Date(moment(week).startOf('week')),
            stepCount: diff,
            disabledBackIcon: moment(week).startOf('week').format('MM-DD-YYYY') !== moment(new Date()).startOf('week').format('MM-DD-YYYY') ? false : true
        })

        this.FilterActivitiesByDate(diff, this.state.CommunitySelected)

    }

    formatWeekSelectLabel = (date = this.state.startSelectedWeek) => {

        let dateClone = new Date(this.state.startSelectedWeek);

        if (moment(dateClone).startOf('week').format('YYYY') !== moment(dateClone).endOf('week').format('YYYY')) {
            return dateClone && isValid(dateClone)
                ? `${moment(dateClone).startOf('week').format('MMM DD YYYY')} - ${moment(dateClone).endOf('week').format('MMM DD YYYY')}`
                : '';
        }

        return dateClone && isValid(dateClone)
            ? `${moment(dateClone).startOf('week').format('MMM DD')} - ${moment(dateClone).endOf('week').format('MMM DD YYYY')}`
            : '';
    };

    handleSelectDay = (day) => {
        const currentDay = moment(new Date()).startOf('day').format()
        const selected = moment(day).startOf('day').format()

        const msInDay = 1000 * 60 * 60 * 24;

        const diff = Math.round(Math.abs(new Date(currentDay) - new Date(selected)) / msInDay)

        this.setState({
            daySelected: new Date(selected),
            stepCount: diff,
            disabledBackIcon: moment(day).format('MM/DD/YYYY') !== moment(new Date()).format('MM/DD/YYYY') ? false : true
        });

        this.FilterActivitiesByDate(diff, this.state.CommunitySelected)



    }

    formatSelectedDayLabel = (date = this.state.daySelected) => {

        let dateClone = new Date(this.state.daySelected);

        return dateClone && isValid(dateClone)
            ? `${moment(dateClone).format('MMM DD YYYY')}`
            : '';
    }

    handleReset = () => {

        if (this.state.schedulerOptionSelected.name === 'Monthly') {
            //get current month
            const current = this.state.months.indexOf(this.state.currentMonth);

            this.setState({ currentMonth: this.state.months[0], stepCount: 0, disabledBackIcon: true })

            this.FilterActivitiesByDate(-current, this.state.CommunitySelected)


        } else if (this.state.schedulerOptionSelected.name === 'Weekly') {
            const msInWeek = 1000 * 60 * 60 * 24 * 7;

            const startWeek = moment(this.state.currentDate).startOf('week').format()

            const diff = Math.round(Math.abs(new Date(startWeek) - new Date(this.state.startSelectedWeek)) / msInWeek)
            this.setState({ startSelectedWeek: new Date(startWeek), stepCount: 0, disabledBackIcon: true })

            this.formatWeekSelectLabel(new Date(startWeek))
            this.FilterActivitiesByDate(-diff, this.state.CommunitySelected)

        } else if (this.state.schedulerOptionSelected.name === 'Daily') {
            const msInDay = 1000 * 60 * 60 * 24;

            const startDay = moment(this.state.currentDate).startOf('day').format()

            const diff = Math.round(Math.abs(new Date(startDay) - new Date()) / msInDay)
            this.setState({ daySelected: new Date(startDay), stepCount: 0, disabledBackIcon: true })

            this.formatWeekSelectLabel(new Date(startDay))
            this.FilterActivitiesByDate(-diff, this.state.CommunitySelected)

        }
    }

    fnBrowserDetect() {

        let userAgent = navigator.userAgent;
        let isSafari = false;
        if (userAgent.match(/safari/i)) 
            isSafari = true;

        return isSafari
    }

    render() {

        const shouldReturnToHome = (this.props.returnToHome && this.props.returnToHome === 'true') ? true : false;
        if (this.props.UpdateCurrentLocation && shouldReturnToHome) {

            this.setState(
                {
                    schedulerOptionSelected: { name: 'Monthly' },
                    stepCount: 0,
                    disabledBackIcon: true
                },
                () => {
                    this.props.UpdateCurrentLocation('false');
                })
        }

        const isSuperAdmin = localStorage.getItem('superAdmin') ? (localStorage.getItem('superAdmin') === "true") : false;

        if (
            (this.state.CommunitySelected === undefined) &&
            (this.props.communityData && this.props.communityData.length > 0) &&
            (isSuperAdmin && localStorage.getItem('communityId') && localStorage.getItem('communityId').length > 0)
        ) {
            this.SearchCommunityObject(localStorage.getItem('communityId'));
        }
        else if (
            (this.state.CommunitySelected === undefined) &&
            (this.props.communityData && this.props.communityData.length > 0) &&
            (isSuperAdmin === false && localStorage.getItem('communityId') && localStorage.getItem('communityId').length > 0)
        ) {
            this.SearchCommunityObject(localStorage.getItem('communityId'));
        }

        return (
            <React.Fragment>
                <AppBar position="static" className="dark">
                    {/* {Toolbar combo super User} */}
                    <Toolbar>
                        <Grid container >
                            <Grid item container xs={2}>
                                <Typography variant="h6" >
                                    <div className={this.Styles.title}>
                                        {/* { 'Scheduler' } */}
                                    </div>
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} sm={6} md={6} lg={6} style={this.Styles.globalActions} >
                                {

                                    <Grid item container xs={12} justify='flex-end' alignItems='center' style={this.Styles.globalActions}>
                                        {
                                            (isSuperAdmin && isSuperAdmin === true) ?
                                                <Grid item container xs={12} style={{ paddingLeft: '15px', marginRight: '15px', }} justify='center' alignContent='center' >
                                                    <SuperUserDropDown
                                                        stateOpen={this.state.open}
                                                        localStorageSetItem={this.localStorageSetItem}
                                                        localStorageRemoveItem={this.localStorageRemoveItem}
                                                        SetHeaderButtonn={this.SetHeaderButtons}
                                                        handleCommunityCombo={this.handleCommunityCombo}
                                                        setState={this.setLocalState}
                                                        communityData={this.props.communityData}
                                                        superUserCommunitySelected={this.state.CommunitySelected ? this.state.CommunitySelected : {}}
                                                        openCommunityCombo={this.state.openCommunityCombo}
                                                        handleCommunityOnBlur={this.handleCommunityOnBlur}
                                                        GetCategories={this.GetCategories}
                                                        FilterActivitiesByDate={this.FilterActivitiesByDate}
                                                    />
                                                </Grid>
                                                :
                                                undefined
                                        }
                                        
                                    </Grid>
                                }
                            </Grid>
                        </Grid>
                    </Toolbar>
                    <Toolbar>
                        <Grid container className='ToolBarScheduler' >
                            <Grid item container xs={4} sm={4} md={2} lg={2} direction='row' justify='flex-end'>
                                <Grid item container xs={11}>
                                    {/* <this.RenderScheduleroptionselect/> */}
                                    {/* {/* <SwitchTwoOptions
                                        idToSet='scheduler_switch_two_options'
                                        leftOptionLabel='Month'
                                        rightOptionLabel='Week'
                                        selectedOption={this.state.openWeekView === false ? 0 : 1}
                                        onOptionChange={(optionselected) => this.ToggleScaleSelected(optionselected)}
                                    /> */}
                                    {/* < options={}/> */}
                                    <Field
                                        showStartAdornment={true}
                                        name="SchedulerSelect"
                                        label="Schedule"
                                        maxLength={20}
                                        optionSelected={this.state.schedulerOptionSelected ? this.state.schedulerOptionSelected : { name: '' }}
                                        options={this.state.schedulerOptions ? this.state.schedulerOptions : []}
                                        onChangeHandler={(e, newItem) => this.onChangeSelectHandler(newItem)}
                                        component={RenderSelectCustom}
                                        open={this.state.openSchedulerCompo}
                                        onClick={this.openHandlerRenderSelectCustom}
                                        onBlur={this.onBlurRenderSelectCustom}
                                        diableClear={true}
                                        inputLabelClass='RenderSelectCustomClass'
                                        autoCompleteStyles={{ paddingRight: '0px' }}
                                        startAdornment={<Grid style={{ padding: '0px 5px' }}><FarCalendarAlt className="scheduleAdornment" /></Grid>}
                                        idToSet="SchedulerSelect"
                                        id='SchedulerSelect'
                                    />

                                </Grid>
                            </Grid>
                            <Grid item container xs={5} sm={5} md={5} lg={4} direction='row'>
                                <Grid item container xs={12} justify='center' alignItems='center'>
                                    <Grid item container id={'schedule_leftArrow'} xs={2} md={2} justify='center' alignItems='center'>
                                        <IconButton aria-label="leftArrow" onClick={() => this.AddStep(-1)} id='scheduler_left_arrow' disabled={this.state.disabledBackIcon}>
                                            <ArrowBackIosIcon style={{ fontSize: 40, color: (this.state.disabledBackIcon === false) ? '#009EDD' : 'white' }} />
                                        </IconButton>
                                    </Grid>
                                    <Grid item container id={'schedule_optionSelected'} xs={8} md={6} justify='center' alignItems='center' style={{ color: 'white', fontSize: '2rem', textAlign: 'center' }}>

                                        {
                                            (this.state.schedulerOptionSelected && this.state.schedulerOptionSelected.name && this.state.schedulerOptionSelected.name.toLowerCase() === 'monthly') ?

                                                <Autocomplete
                                                    id='months_dropdown'
                                                    fullWidth
                                                    options={this.state.months}
                                                    value={this.state.currentMonth}
                                                    name="Month"
                                                    getOptionSelected={(option, value) => option === value ? true : false}
                                                    getOptionLabel={option => option}
                                                    disableClearable
                                                    renderOption={option => {
                                                        return (
                                                            <Grid item container xs={12}>
                                                                <Grid item xs={1}>
                                                                    {
                                                                        this.state.currentMonth === option &&
                                                                        <FontAwesomeIcon
                                                                            icon={faCheck}
                                                                            color='white'
                                                                            size='1x'
                                                                        />
                                                                    }
                                                                </Grid>

                                                                <span style={{ marginLeft: '10px', fontFamily: 'Gotham-Book' }}>{option}</span>
                                                            </Grid>
                                                        )
                                                    }}
                                                    classes={{
                                                        listbox: "roomsAutocompleteListbox"
                                                    }}
                                                    renderInput={(params) => {
                                                        return (<>
                                                            <TextField
                                                                {...params}
                                                                className='registrations_select'
                                                                style={{ fontSize: '20px' }}
                                                                InputProps={{ ...params.InputProps, disableUnderline: true }}
                                                            />
                                                        </>
                                                        )
                                                    }}
                                                    clearOnEscape={true}
                                                    onChange={(e, newItem) => this.handleSelectMonth(newItem)}
                                                />

                                                :
                                                (this.state.schedulerOptionSelected && this.state.schedulerOptionSelected.name && this.state.schedulerOptionSelected.name.toLowerCase() === 'weekly') ?
                                                    <>
                                                        <Field
                                                            name="Week"
                                                            selectedDate={this.state.startSelectedWeek} //most be an date object is use in both date and time
                                                            onDateChange={(date) => this.handleSelectWeek(date)}
                                                            component={WeeklySelectionTool}
                                                            renderLabel={this.formatWeekSelectLabel}
                                                            idToSet='Week_selection_tool'
                                                            id='Week_selection_tool'
                                                        />
                                                    </>
                                                    :
                                                    <Field
                                                        name="Day Selected"
                                                        selectedDate={this.state.daySelected}
                                                        onDateChange={(date) => this.handleSelectDay(date)}
                                                        component={DaySelectionTool}
                                                        renderLabel={this.formatSelectedDayLabel}
                                                        idToSet='schedule_daily_calendar'
                                                        id='schedule_daily_calendar'
                                                    />
                                        }
                                    </Grid>
                                    <Grid item container id={'schedule_leftArrow'} xs={2} md={2} justify='center' alignItems='center'>
                                        <IconButton aria-label="RightArrow" onClick={() => this.AddStep(1)} id='scheduler_right_arrow'>
                                            <ArrowForwardIosIcon color='secondary' style={{ fontSize: 40 }} />
                                        </IconButton>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item container xs={3} sm={2} md={2} lg={2}>

                                {
                                    (
                                        (this.state.schedulerOptionSelected.name === 'Monthly' && this.state.currentMonth !== moment(new Date()).format('MMM YYYY'))
                                        ||
                                        (this.state.schedulerOptionSelected.name === 'Weekly' && this.state.startSelectedWeek.getTime() !== new Date(moment(new Date()).startOf('week').format()).getTime())
                                        ||
                                        (this.state.schedulerOptionSelected.name === 'Daily' && moment(this.state.daySelected).format('MM/DD/YYYY') !== moment(new Date()).format('MM/DD/YYYY'))
                                    ) &&
                                    <Button className='reset_btn' onClick={this.handleReset}>Reset to current</Button>
                                }
                            </Grid>
                            <Grid item container xs={12} sm={5} md={4} lg={4} justify='flex-end' alignItems='center' direction='row'>
                                <Grid item id='filtersButton' onClick={this.state.CommunitySelected ? this.onClickFiltersPopOver : undefined}>
                                    <IconButton aria-label="FilterListIcon" id='scheduler_filters_btn'>
                                        {
                                            this.state.openActivityFiltersPopOver ?
                                                <IconButton
                                                    aria-label="SearchIcon"
                                                >
                                                    <HighlightOffIcon
                                                        style={this.state.rootFontSize && (this.state.rootFontSize.name === 'xl' || this.state.rootFontSize.name === 'lg') ? { fontSize: '40px', color: '#9c9b9c', cursor: 'pointer' } : { fontSize: '30px', color: '#9c9b9c', cursor: 'pointer' }}
                                                    />
                                                </IconButton>
                                                :
                                                <FontAwesomeIcon
                                                    style={this.state.rootFontSize && (this.state.rootFontSize.name === 'xl' || this.state.rootFontSize.name === 'lg') ? { fontSize: '30px', color: '#9c9b9c' } : { fontSize: '25px', color: '#9c9b9c' }}
                                                    className=""
                                                    icon={faFilter}
                                                />
                                        }

                                    </IconButton>
                                </Grid>
                                {
                                    // <Grid item>
                                    //     <ReactToPrint
                                    //         trigger={() => (
                                    //             <IconButton aria-label="GetAppIcon" id='scheduler_print_btn'>
                                    //                 <PrintIcon color='secondary' style={this.state.rootFontSize && (this.state.rootFontSize.name === 'xl' || this.state.rootFontSize.name === 'lg') ? { fontSize: 40, color: '#9c9b9c' } : { fontSize: 30, color: '#9c9b9c' }} />
                                    //             </IconButton>
                                    //         )}
                                    //         content={() => this.componentRef}
                                    //     />
                                    // </Grid>

                                    // <Grid item>
                                    //     <Pdf targetRef={this.state.pdfRef} options={printingOptions} filename="div-blue.pdf"  scale={1}>
                                    //         {({toPdf}) => (
                                    //             <IconButton aria-label="GetAppIcon" id='scheduler_print_btn'>
                                    //                 <PrintIcon 
                                    //                     color='secondary' 
                                    //                     style={this.state.rootFontSize && (this.state.rootFontSize.name === 'xl' || this.state.rootFontSize.name === 'lg') ? { fontSize: 40, color: '#9c9b9c' } : { fontSize: 30, color: '#9c9b9c' }} 
                                    //                     onClick={toPdf}
                                    //                     />
                                    //             </IconButton>
                                    //         )}
                                    //     </Pdf>
                                    // </Grid>
                                    <>
                                        {
                                            /*
                                                <Grid item>
                                                    <IconButton aria-label="GetAppIcon" id='scheduler_print_btn'>
                                                        <PrintIcon
                                                            color='secondary'
                                                            style={this.state.rootFontSize && (this.state.rootFontSize.name === 'xl' || this.state.rootFontSize.name === 'lg') ? { fontSize: 40, color: '#9c9b9c' } : { fontSize: 30, color: '#9c9b9c' }}
                                                            onClick={this.GenerateImageFromCalendar}
                                                        />
                                                    </IconButton>
                                                </Grid>
                                            */
                                        }

                                        <ReactToPrint
                                            trigger={() =>
                                                <IconButton aria-label="GetAppIcon" id='scheduler_print_btn'>
                                                    <PrintIcon
                                                        color='secondary'
                                                        style={this.state.rootFontSize && (this.state.rootFontSize.name === 'xl' || this.state.rootFontSize.name === 'lg') ? { fontSize: 40, color: '#9c9b9c' } : { fontSize: 30, color: '#9c9b9c' }}
                                                    />
                                                </IconButton>
                                            }
                                            documentTitle={`${this.state.schedulerOptionSelected.name.toLowerCase()}_schedulerPrint`}
                                            content={() => this.componentRef}
                                        />
                                    </>
                                }

                            </Grid>
                        </Grid>
                    </Toolbar>
                </AppBar>
                {
                    this.state.openAddCategoryModal === true ?
                        <AddCategoryModal
                            setUpdateIsNeeded={this.setUpdateIsNeeded}
                            rootFontSize={this.state.rootFontSize}
                            onClose={this.handleClose}
                            communityId={localStorage.getItem('communityId')}
                            category={this.state.categorySelected}
                        />
                        :
                        undefined
                }
                {/* {
                    this.state.openAddEventModal === true ?
                        <AddEventModal
                            rootFontSize={this.state.rootFontSize}
                            OnCreateEventClick={this.OnCreateEventClick}
                            onClose={() => this.setState({ openAddEventModal: false })}
                        />
                        :
                        undefined
                } */}
                {
                    this.state.openActivityDetailsModal === true && this.state.activityDetailsIdAnchorEl && this.state.activityDetailsActivityObject ?
                        <ActivityDetailsModal
                            idAnchorEl={this.state.activityDetailsIdAnchorEl}
                            activityObj={this.state.activityDetailsActivityObject}
                            onCloseActivityDetails={this.onCloseActivityDetails}
                            timeZoneName={(this.state.CommunitySelected && this.state.CommunitySelected.timeZoneName) ? this.state.CommunitySelected.timeZoneName : 'America/New_York'}
                            OnGoToActivity={this.OnGoToActivity}
                        />
                        :
                        undefined
                }
                {
                    this.state.openActivityFiltersPopOver === true && this.state.activityFiltersAnchorElId ?
                        <ActivityFiltersDrawer
                            idAnchorEl={this.state.activityFiltersAnchorElId}
                            onClose={() => this.setState({ openActivityFiltersPopOver: false })}
                            categories={this.props.categoriesData ? this.props.categoriesData.map(item => ({ ...item, name: item.name.trim() })).sort((a, b) => a.name.toUpperCase() > b.name.toUpperCase()) : []}
                            activities={this.state.activitiesNames ? this.state.activitiesNames.sort((a, b) => a.name.toUpperCase() > b.name.toUpperCase()) : []}
                            onFilterChange={this.onFilterChange}
                            filterObj={this.state.filterObj ? this.state.filterObj : {}}
                        />
                        :
                        undefined
                }

                <Grid item container justify='center'>
                    {
                        (
                            (this.state.CommunitySelected) &&
                            (
                                (this.state.openAddCategoryModal === false) &&
                                (this.state.openAddEventModal === false)
                            )
                        ) ?
                            (this.state.schedulerOptionSelected && this.state.schedulerOptionSelected.name.toLowerCase() === 'weekly') ?
                                <Grid item container class='schedulerContainer' style={{ padding: '50px' }}>
                                    <div id="printableTable" className={this.fnBrowserDetect() ? 'printSafariStyles' : ''} ref={el => (this.componentRef = el)}>
                                        <SchedulerWeekView
                                            idToSet={'canvasContainer'}
                                            updateIsNeeded={this.state.updateIsNeeded}
                                            setUpdateIsNeeded={this.setUpdateIsNeeded}
                                            OnActivityClick={this.OnActivityClick}
                                            stepCount={this.state.stepCount}
                                            communitySelected={this.state.CommunitySelected}
                                            filterObj={this.state.filterObj ? this.state.filterObj : {}}
                                            onFilter={this.onFilterChange}
                                        />
                                    </div>
                                </Grid>
                                :
                                (this.state.schedulerOptionSelected && this.state.schedulerOptionSelected.name.toLowerCase() === 'monthly') ?
                                    <Grid item container class='schedulerContainer' style={{ padding: '50px' }}  >
                                        <div id="printableTable" className={this.fnBrowserDetect() ? 'printSafariStyles' : ''} ref={el => (this.componentRef = el)}>
                                            <SchedulerMonthView
                                                idToSet={'canvasContainer'}
                                                updateIsNeeded={this.state.updateIsNeeded}
                                                setUpdateIsNeeded={this.setUpdateIsNeeded}
                                                OnActivityClick={this.OnActivityClick}
                                                stepCount={this.state.stepCount}
                                                communitySelected={this.state.CommunitySelected}
                                                filterObj={this.state.filterObj ? this.state.filterObj : {}}
                                                onFilter={this.onFilterChange}
                                            />
                                        </div>
                                    </Grid>
                                    :
                                    (this.state.schedulerOptionSelected && this.state.schedulerOptionSelected.name.toLowerCase() === 'daily') ?
                                        <Grid item container class='schedulerContainerPortrait' style={{ paddingTop: '50px' }}>
                                            <div id="printableTable" ref={el => (this.componentRef = el)} >
                                                <SchedulerDailyView
                                                    idToSet={'canvasContainer'}
                                                    updateIsNeeded={this.state.updateIsNeeded}
                                                    setUpdateIsNeeded={this.setUpdateIsNeeded}
                                                    OnActivityClick={this.OnActivityClick}
                                                    stepCount={this.state.stepCount ? this.state.stepCount : 0}
                                                    communitySelected={this.state.CommunitySelected}
                                                    filterObj={this.state.filterObj ? this.state.filterObj : {}}
                                                    onFilter={this.onFilterChange}
                                                />
                                            </div>
                                        </Grid>
                                        :
                                        undefined
                            :
                            undefined
                    }
                </Grid>
                {/* Categories Seccion */}

                <iframe id='print_frame' title='print_title' name="print_frame" width="0" height="0" frameborder="0" src="about:blank"></iframe>

                {
                    this.state.imagePreview ?
                        <SchedulerImagePreview
                            schedulerImage={this.state.imagePreview ? this.state.imagePreview : undefined}
                            onCloseModal={this.onCloseImagePreviewModal}
                            schedulerType={this.state.schedulerOptionSelected.name}
                        />
                        :
                        undefined
                }
            </React.Fragment>
        );
    }
}


function mapStateToProps(state) {

    let communityData = (state.communityReducer && state.communityReducer.communityData) ? state.communityReducer.communityData.map(item => ({ _id: item._id, name: item.communityName, communityId: item.communityId, timeZoneName: item.timeZoneName, timeZone: item.timeZone, communityLogoUrl: item.communityLogoUrl })) : [];
    const categoryData = (state.categoryReducer && state.categoryReducer.categoryData) ? state.categoryReducer.categoryData : [];
    let activitiesData = (state.activityReducer && state.activityReducer.calendarActivityData) ? state.activityReducer.calendarActivityData : [];
    let returnToHome = (state && state.currentUrlReducer && state.currentUrlReducer.returnToHome) ? state.currentUrlReducer.returnToHome : 'false'

    if (communityData) {
        communityData =
            communityData.map((item, index) => {
                item.indexForCombo = index;
                return item;
            })
    }
    return {
        tableData: undefined,
        categoriesData: categoryData,
        communityData: communityData,
        activitiesData: activitiesData,
        returnToHome: returnToHome,
    };
};


export default connect(
    mapStateToProps,
    { GetCategoriesByCommunityId, GetCategoryIcons, SetHeaderButtons, DeleteCategory, GetCalendarActivities, getAllCommunities, UpdateCurrentLocation }
)(
    reduxForm({
        form: 'SchedulerForm',
        validate,
    })(Scheduler));
